/** Whole-rupiah amount. PRD invariant 3: never binary floating point for money. */
export type Idr = bigint;

export function idr(value: string | number | bigint): Idr {
  if (typeof value === "number" && !Number.isSafeInteger(value)) {
    throw new RangeError(`IDR amount must be a safe integer, got ${value}`);
  }
  return BigInt(value);
}

/** Percentage discount in basis points (1000 = 10%), rounded half-up to whole rupiah. */
export function applyPercentDiscount(amount: Idr, basisPoints: bigint): Idr {
  const discount = (amount * basisPoints + 5_000n) / 10_000n;
  return amount - discount;
}

/** "Rp45.000" in Indonesian, "Rp45,000" in English: the grouping follows `locale`, the currency stays Rp. */
export function formatIdr(amount: Idr, locale = "id-ID"): string {
  return `Rp${amount.toLocaleString(locale)}`;
}
